import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import GridSeparator from './_grid-separator.js'
import DateTime from './_date-time.js'
import GridPane from './_grid-pane.js'
import Image from './_image.js'

export default {
  name: 'BonusItems',
  values: {
    headerColumns: [
      'name',
      'description',
      'expiry',
      'total',
      'remaining',
      'status',
    ],
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '8px 8px 6px 8px',
          height: '100%',
        },
      },
    },
    compactContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    compactContainerInner: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '0px 0px 7px 0',
        },
      },
    },
    title: {
      configSet: Text,
      configValues: {
        truncate: true,
      },
    },
    expiry: {
      configSet: Text,
      configValues: {},
    },
    status: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
        style: {
          textAlign: 'right',
        },
      },
    },
    amountAndRemainingAmount: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    onlyAmount: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    remainingAmount: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    description: {
      configSet: Text,
      configValues: {},
    },
    expireDateContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '4px 0',
          justifyContent: 'space-between',
        },
      },
    },
    amountContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '4px 0',
          justifyContent: 'space-between',
        },
      },
    },
    remainingAmountContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '4px 0',
          justifyContent: 'space-between',
        },
      },
    },
    columnItem: {
      configSet: FlexPane,
      configValues: {
        style: {
          alignItems: 'center',
          minHeight: '60px',
          padding: '0 6px',
        },
      },
    },
    textItem: {
      configSet: Text,
      configValues: {},
    },
    textItemAlignedEnd: {
      configSet: Text,
      configValues: {
        style: {
          textAlign: 'end',
        },
      },
    },
    textItemCenter: {
      configSet: Text,
      configValues: {
        style: {
          textAlign: 'center',
        },
      },
    },
    gridSeparator: {
      configSet: GridSeparator,
      configValues: {
        bottomSeparator: {
          style: {
            margin: '-1px 0 0 0',
            gridColumnStart: 1,
            gridColumnEnd: 7,
          },
        },
      },
    },
    compactLayout: true,
    _desktop_compactLayout: false,
    expireDateTimeFormat: {
      configSet: DateTime,
      configValues: {
        format: 'FULL_DATE_TIME',
      },
    },
    listContainer: {
      configSet: GridPane,
      configValues: {},
    },
    headerStyle: {
      configSet: Text,
      configValues: {
        container: {
          padding: '8px',
        },
      },
    },
    headerStyleAlignedEnd: {
      configSet: Text,
      configValues: {
        container: {
          padding: '8px',
        },
        style: {
          textAlign: 'end',
        },
      },
    },
    headerStyleCenter: {
      configSet: Text,
      configValues: {
        container: {
          padding: '8px',
        },
        style: {
          textAlign: 'center',
        },
      },
    },
    freeBetsIcon: {
      configSet: Image,
      configValues: {
        src: 'freebet-filled',
        style: {
          minWidth: '24px',
          minHeight: '24px',
          padding: '0 8px 0 0',
        },
      },
    },
    oddsBoostIcon: {
      configSet: Image,
      configValues: {
        src: 'promotion-boost',
        style: {
          minWidth: '24px',
          minHeight: '24px',
          padding: '0px 8px 0 0px',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
